<template>
    <div class="collection">
        <header>
            <div class="header">
                <h2>我的关注</h2>
            </div>
            <div class="line"></div>

            <div class="tabs">
                <span @click="currentTab = 1; query();" :class="{ active: currentTab == 1 }">我的关注</span>
                <span @click="currentTab = 2; query();" :class="{ active: currentTab == 2 }">我的粉丝</span>
            </div>
        </header>
        <div class="query_box">
            <!-- <span @click="() => sortPickerRef.openPicker()">模型排序 <van-icon name="arrow-down" /></span> -->
        </div>
        <van-list v-model:loading="loading" :finished="finished" finished-text="没有更多了" @load="onLoad">
            <ul class="follow_list" v-if="currentTab == 1"  v-show="list.length > 0">
                <li v-for="item in list" :key="item.id">
                    <img :src="item.avatar">
                    <p>{{ item.nickname || item.username }}</p>
                    <p><b>{{ item.modelCount }}</b>作品 · <b>{{ item.fansCount }}</b>粉丝</p>
                    <button @click="cancelFollow(item.userId)">取消关注</button>
                    <p style="color: #A6A6A6; font-size: 12rem;">{{ timeStampFormat(item.createTime) }} 关注</p>
                </li>
            </ul>
            <ul class="fan_list" v-else  v-show="list.length > 0">
                <li>
                    <span style="color: #717171;">用户名</span>
                    <span style="color: #717171;">作品</span>
                    <span style="color: #717171;">粉丝</span>
                    <span style="color: #717171;"></span>
                </li>
                <li v-for="item in list" :key="item.id">
                    <span>
                        <img :src="item.avatar">
                        {{ item.nickname || item.username }}
                    </span>
                    <span>{{ item.modelCount }}</span>
                    <span>{{ item.fansCount }}</span>
                    <span><button>关注</button></span>
                </li>
            </ul>
        </van-list>
    </div>
    <SortPicker ref="sortPickerRef" @confirm="d => { queryParams.modelSort = d[0].id; query(); }" />
</template>

<script setup>
import { http } from '@/request/http'
import { onMounted, reactive, ref, toRaw, watch, computed } from 'vue'
import SortPicker from '@/views/workbench/components/sortPicker.vue'
import { timeStampFormat } from '@/utils/util'

const sortPickerRef = ref(null)
const currentTab = ref(1)

const pagination = reactive({
    pageNo: 1,
    pageSize: 10
})
const total = ref(0)
const loading = ref(false)
const finished = ref(false)
const list = ref([])
const fetchList = () => {
    loading.value = true
    if (currentTab.value == 1) {
        http.get('/app-api/member/follow/myFollow', {
            params: Object.assign({}, pagination)
        }).then(res => {
            loading.value = false
            finished.value = res.list.length < pagination.pageSize
            total.value = res.total
            list.value = [...list.value, ...res.list]

        })
    } else {
        http.get('/app-api/member/follow/myFans', {
            params: Object.assign({}, pagination)
        }).then(res => {
            loading.value = false
            finished.value = res.list.length < pagination.pageSize
            total.value = res.total
            list.value = [...list.value, ...res.list, ...res.list]
        })
    }
}
const onLoad = () => {
    pagination.pageNo++
    fetchList()
}
const query = () => {
    pagination.pageNo = 1
    list.value = []
    finished.value = false
    fetchList()
}
onMounted(() => {
    fetchList()
})
const cancelFollow = (userId) => {
    http.post('/app-api/member/follow/follow', {
        userId: userId
    }).then(res => {
        fetchList()
    })
}
</script>

<style lang="scss" scoped>
@use '../common.scss';

.collection {
    background-color: #F6F6F6;
    min-height: 100vh;

    header {
        padding: 15rem;
        background-color: #fff;

        .header {
            width: 100%;
            display: flex;
            justify-content: space-between;
            align-items: center;

            img {
                height: 29rem;
            }
        }
    }

    .query_box {
        padding: 15rem;
        display: flex;
        justify-content: flex-end;
    }

    .follow_list {
        display: grid;
        grid-template-columns: repeat(2, 1fr);
        grid-gap: 15rem;
        background-color: #fff;
        padding: 15rem;
        margin: 0 15rem;
        li {
            display: flex;
            flex-direction: column;
            background-color: #F8F8F8;
            align-items: center;
            justify-content: center;
            padding: 15rem;

            img {
                height: 60rem;
                width: 60rem;
                border-radius: 50%;
                margin-bottom: 10rem;
            }

            button {
                width: 120rem;
                height: 26rem;
                line-height: 20rem;
                color: #0A84FF;
                border: 1px solid #0A84FF;
                margin-top: 10rem;
                background: transparent;
            }

            p {
                height: 30rem;
                line-height: 30rem;
                color: #383838;

                b {
                    color: #FF8D1A;
                }
            }
        }
    }

    .fan_list {
        background-color: #fff;
        padding: 15rem;
        margin: 0 15rem;
        min-height: 150rem;
        li {
            display: flex;
            align-items: center;
            height: 70rem;
            padding: 15rem 0;
            border-bottom: 1px solid #F4F4F5;
            span {
                display: flex;
                height: 100%;
                align-items: center;
                img {
                    width: 40rem;
                    height: 40rem;
                    border-radius: 50%;
                }
            }

            span:nth-child(1) {
                width: 40%;
            }

            span:nth-child(2) {
                width: 20%;
            }

            span:nth-child(3) {
                width: 20%;
            }

            span:nth-child(4) {
                width: 20%;
            }

            button{
                width: 100%; height: 26rem; background-color: #000000; color: #FFF; border: none;
            }
        }
    }
}
</style>